import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = 2026;

  return (
    <footer className="bg-brand-dark border-t border-white/10 py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center gap-10 mb-10">
          {/* Logo + tagline */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <AppLogo size={48} />
            <p className="text-white/40 text-sm font-body max-w-xs text-center md:text-left">
              Uganda&apos;s trusted auto truck spare parts supplier for East Africa.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-8 text-xs font-heading font-bold uppercase tracking-widest text-white/40">
            <a href="#brands" className="hover:text-brand-yellow transition-colors">Brands</a>
            <a href="#categories" className="hover:text-brand-yellow transition-colors">Parts</a>
            <a href="#why-us" className="hover:text-brand-yellow transition-colors">About</a>
            <a href="#contact" className="hover:text-brand-yellow transition-colors">Contact</a>
            <a href="tel:+256772500220" className="hover:text-brand-yellow transition-colors">Call Us</a>
          </div>

          {/* Social / Contact Icons */}
          <div className="flex gap-3">
            <a
              href="https://wa.me/256772500220"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-green-600 hover:border-green-600 transition-all"
              aria-label="WhatsApp number 1"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" className="text-white">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
            </a>
            <a
              href="mailto:baninvestltd@gmail.com"
              className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-red hover:border-brand-red transition-all"
              aria-label="Email Baninvest"
            >
              <Icon name="EnvelopeIcon" size={16} className="text-white" />
            </a>
            <a
              href="tel:+256772500220"
              className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center hover:bg-brand-blue hover:border-brand-blue transition-all"
              aria-label="Call Baninvest"
            >
              <Icon name="PhoneIcon" size={16} className="text-white" />
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-body text-white/25 uppercase tracking-widest">
          <p>&copy; {currentYear} Baninvest Limited. All rights reserved.</p>
          <p>Mengo Hill Road, PO BOX 133230, Kampala, Uganda</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white/50 transition-colors">Privacy</a>
            <a href="#" className="hover:text-white/50 transition-colors">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}